import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Tag as AntDTag} from "antd";
import {TagStatus} from "./types";

export type TagStatusType = TagStatus

interface TagInterface {
    status: TagStatusType
    defaultStatus?: TagStatusType
}

const Tag: React.FC<TagInterface> = ({status, defaultStatus}) => {
    const parameters = {
        [TagStatus.IN_PROGRESS]: {
            color: 'blue',
            messageId: `general.${status?.toLowerCase()}`,
        },
        [TagStatus.COMPLETED]: {
            color: 'green',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.MISSED]: {
            color: 'red',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.CANCELLED]: {
            color: 'red',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.FAILED]: {
            color: 'red',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.RETURNED]: {
            color: 'blue',
            messageId: 'courses.topic_status.submission_returned',
        },
        [TagStatus.INVITE_ENROLLMENT]: {
            color: 'blue',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.SELF_ENROLLMENT]: {
            color: 'green',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.NOT_STARTED]: {
            color: 'gold',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.PASSED]: {
            color: 'green',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.PLANNED]: {
            color: 'geekblue',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.ATTENDED]: {
            color: 'green',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.COMPLIANT]: {
            color: 'lime',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.NOT_REGISTERED]: {
            color: 'orange',
            messageId: `general.${status ? status?.toLowerCase() : defaultStatus?.toLowerCase()}`,
        },
        [TagStatus.NOT_APPLICABLE]: {
            color: 'orange',
            messageId: `lectures.status_NOT_APPLICABLE`,
        },
        [TagStatus.FINAL_ASSESSMENT]: {
            color: 'blue',
            messageId: `courses.topic_status.final_assessment`,
        },
        [TagStatus.ACTIVE]: {
            color: 'green',
            messageId: 'general.active',
        },
        [TagStatus.INACTIVE]: {
            color: 'red',
            messageId: 'general.inactive',
        },
        [TagStatus.NOT_SUBMITTED]: {
            color: 'gold',
            messageId: `courses.topic_status.not_submitted`,
        },
        [TagStatus.SUBMITTED]: {
            color: 'blue',
            messageId: `courses.topic_status.submitted`,
        },
        [TagStatus.EVALUATION]: {
            color: 'blue',
            messageId: `courses.topic_status.evaluation`,
        },
        [TagStatus.MISSED_DEADLINE]: {
            color: 'red',
            messageId: `courses.topic_status.missed_deadline`,
        },
    }

    return (
        <AntDTag color={parameters[status ? status : (defaultStatus ? defaultStatus : 'NOT_STARTED')].color}>
            <FormattedMessage
                id={parameters[status ? status : (defaultStatus ? defaultStatus : 'NOT_STARTED')].messageId}/>
        </AntDTag>
    );
};

export default Tag;